<template>
    <div :class="{'content-modal-mode' : modalMode}"
         v-observe-visibility="enableStickyCloseBtn && {
                    callback: isContentVisible,
                    intersection: {
                       threshold: 0.025,
                    }
             }"
         :ref="'blockContentPopup'"
    >
        <section class="block-content-popup themed-scrollbar"
                 :class="{'minimal' : minimalMode, 'overflow-content' : overflowContent, 'fs-modal' : modalMode}"
                 :id="id"
        >
            <div v-if="!minimalMode" class="block-content-header" id="blockContentHeader">
                {{ headerTitle }}
            </div>
            <i class="close-btn prz-close"
               @click="closeBlockContent"
               ref="contentCloseBtn"
               id="contentCloseBtn"
               v-observe-visibility="enableStickyCloseBtn && {
                    callback: setStickyBtn,
                    intersection: {
                       threshold: 0.1,
                    }
             }"
            />
            <transition name="fade">
                <i v-if="stickyBtn.modalContentVisible && stickyBtn.show" class="close-btn prz-close"
                   :style="{position: 'fixed', top: '88px', right: 'auto', left: `${stickyBtn.leftPos}px`, zIndex: '139'}"
                   @click="closeBlockContent"
                />
            </transition>
            <slot name="content" />
        </section>
    </div>
</template>

<script>
    import {storePdp} from '@/store/product-page';
    import Vue, { defineComponent } from 'vue';
    import { ObserveVisibility } from 'vue-observe-visibility'
    Vue.directive('observe-visibility', ObserveVisibility);
    import utilities from '@/Utilities/common';

    export default {
        storePdp,
        name: "BlockContentPopup",
        components: {},
        props: {
            id: String,
            headerTitle: String,
            minimalMode: {
                type: Boolean,
                default: false
            },
            overflowContent: {
                type: Boolean,
                default: false
            },
            modalMode: {
                type: Boolean,
                default: false
            },
            hasBrowserHistory: {
                type: Boolean,
                default: false
            },
            enableStickyCloseBtn: { // for super long detailed content ex: product description
                type: Boolean,
                default: false
            },
            scrollIntoView: {
                type: Boolean,
                default: false
            },
            stackedModal: { // for non block content modals, ex: pdp special price cpg modal open with others from blocks, etc
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                stickyBtn: {
                    show: false,
                    modalContentVisible: false,
                    leftPos: 0
                }
            };
        },
        computed: {},
        methods: {
            closeBlockContent() {
                if(!this.stackedModal) {
                    storePdp.dispatch('pdpDesktop/addToCartDesktop/updateShowPagePopup', '');
                    this.$emit('select-tab', null);
                }

                this.$emit('close', null);
                if(this.hasBrowserHistory) {
                    history.back();
                }
                document.body.classList.remove('pdp-content-open');
            },
            setStickyBtn(isVisible) {
                this.stickyBtn.show = !isVisible;
            },
            isContentVisible(isVisible) {
                this.stickyBtn.modalContentVisible = isVisible;
            },
            calcBtnPos() {
                this.stickyBtn.leftPos = this.$refs.contentCloseBtn.getBoundingClientRect().left;
            },
            initStickyBtn() {
                if(this.$refs.contentCloseBtn) {
                    this.calcBtnPos();
                } else if(document.getElementById('contentCloseBtn')) {
                    this.calcBtnPos();
                }

                if(this.$refs.contentCloseBtn || document.getElementById('contentCloseBtn')) {
                    window.addEventListener("resize", this.calcBtnPos);
                }
            }
        },
        watch: {},
        beforeDestroy() {
            window.removeEventListener("resize", this.calcBtnPos);
            document.body.classList.remove('pdp-content-open');
        },
        mounted() {
            this.$nextTick(() => {
                if(this.enableStickyCloseBtn) {
                    this.initStickyBtn();
                }
                if(this.scrollIntoView) {
                    utilities.scrollIntoViewWithOffset(this.$refs.blockContentPopup, 76);
                }

                if(this.stackedModal) {
                    document.body.classList.add('pdp-content-open');
                }
            });
        }
    }
</script>

<style lang="scss">
    @import "./styles/BlocksSection/blockContentPopup";
</style>